module.exports = __webpack_public_path__ + "img/trick-question.9c181972.jpg";